import React from 'react';
import './title.css';

function Title({children}) {
  return (
    <h1 className='page-title' >{children}</h1>
  )
}

export default Title